var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5563 4.83062H12.4506C12.4198 4.34012 12.2841 3.64862 11.7958 3.08762C11.2798 2.49437 10.5073 2.19287 9.49935 2.19287C8.4921 2.19287 7.7196 2.49437 7.2036 3.08762C6.71535 3.64862 6.57885 4.34012 6.5481 4.83062H3.44385C3.13335 4.83062 2.88135 5.08262 2.88135 5.39312C2.88135 5.70362 3.13335 5.95562 3.44385 5.95562H15.5563C15.8668 5.95562 16.1188 5.70362 16.1188 5.39312C16.1188 5.08262 15.8668 4.83062 15.5563 4.83062Z",
    fill: "#FF5C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.824 7.69824C14.824 7.49124 14.656 7.32324 14.449 7.32324H4.55198C4.34423 7.32324 4.17698 7.49124 4.17698 7.69824C4.17698 8.44599 4.16348 9.14274 4.15073 9.78849C4.09523 12.6002 4.05848 14.458 5.19473 15.6167C6.00173 16.4395 7.32698 16.807 9.49223 16.807C11.6597 16.807 12.9872 16.4387 13.7965 15.6145C14.938 14.4505 14.902 12.5837 14.8487 9.75624C14.8367 9.11949 14.824 8.43324 14.824 7.69824Z",
    fill: "#FF5C5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.8abee7ef74fa92a80b9c9d5db87847a0.svg";
export { ForwardRef as ReactComponent };